import React from "react";
import SearchTextField from "../../../../components/SearchTextField";
import {useTranslation} from "react-i18next";

const HeaderSearchTextField = () => {
	const { t } = useTranslation();
	const [searchString, setSearchString] = React.useState("");

	return (
		<SearchTextField
			slotProps={{
				input: {
					sx: {
						marginLeft: 2
					}
				}
			}}
			searchString={searchString}
			setSearchString={setSearchString}
			placeholder={t("Search in Youtello")}
		/>
	);
};
export default HeaderSearchTextField;
